import { Col, Icon, Row, Typography } from '@repo/ui/components'
import { ToDateTime, ValueWithUnit } from '@repo/shared/components'
import { type MessagesKeys, useTranslate } from '@repo/shared/hooks'
import { UserTransaction } from '@repo/services'
import Image from 'next/image'
import { cn } from '@repo/ui/lib'

export const RewardItem = ({
  item,
  displayTitle = 'club',
}: {
  item: UserTransaction
  displayTitle?: 'history' | 'club'
}) => {
  const { amount, createdAt, mission, data, userID } = item

  const { t } = useTranslate()

  return (
    <Row className='justify-between gap-md py-xl'>
      {displayTitle === 'history' && (
        <Icon name='PlusLine' color={'fill-positive-surface-100'} size='md' />
      )}
      <Col className='gap-xs item-start text-start '>
        <Col className='gap-xs'>
          <Typography
            size={displayTitle === 'history' ? 'sm' : 'md'}
            weight={displayTitle === 'history' ? 'bold' : 'regular'}
          >
            {t(`clubPage_reward_item_${mission}_title` as MessagesKeys)}{' '}
          </Typography>
          <Typography
            size='xs'
            weight='regular'
            color={
              displayTitle === 'history'
                ? 'text-neutral-surface-100'
                : 'text-neutral-surface-60'
            }
          >
            {data?.fromUserID === userID || mission === 'user_registered'
              ? t('clubPage_reward_item_with')
              : t('clubPage_reward_item_from')}{' '}
            <bdi>
              {data?.fromMaskedPhone?.replace('+98', '0') ||
                data?.fromMaskedEmail}
            </bdi>
          </Typography>
        </Col>
      </Col>

      <div
        className={cn(
          `flex  w-full items-end gap-xs w-fit`,
          displayTitle === 'history' ? 'flex-col-reverse' : 'flex-col',
        )}
      >
        <Row className='w-fit'>
          {/* history token: SQ2: deposit tab  */}

          <ValueWithUnit
            value={amount ?? 0}
            unit={displayTitle === 'history' ? 'crypto' : 'SQ2'}
            valueSize='md'
            betweenChildren={displayTitle === 'history' ? '' : '+'}
            unitPosition={displayTitle === 'club' ? 'before' : 'after'}
          />
          {displayTitle === 'club' && (
            <Image
              src='/images/club-gem.svg'
              alt='coin'
              width={16}
              height={16}
            />
          )}
        </Row>
        <Typography
          size='xs'
          color='text-neutral-surface-60'
          className='min-w-[100px]'
          variant='bdi'
        >
          <ToDateTime date={new Date(createdAt ?? '')} />
        </Typography>
      </div>
    </Row>
  )
}
